module.exports = __webpack_public_path__ + "static/media/device-integration.0449fbb0.svg";